import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import AppConstants from "../../../Constants/AppConstants";
const AddPruefGroup = (props) => {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const {
    prufePlanDetails,
    closeAddEditPruefGroupPopUpCallback,
    equipmentGrpName,
  } = props;
  const [pruefGroup, setPruefGroup] = useState("");
  const [pruefGroupId, setPruefGroupId] = useState(AppConstants.DEFAULT_GUID);
  const updateSelectedConfig = useSelectedConfigActionContext();

  //------------------------Edit PrufePlan start ----------------------
  useEffect(() => {
    setPruefGroup(prufePlanDetails ? prufePlanDetails.bezeichnung : "");
    setPruefGroupId(
      prufePlanDetails.id ? prufePlanDetails.id : AppConstants.DEFAULT_GUID
    );
  }, [props]);

  const pruefGroupAdd = (e) => {
    e.preventDefault();
    const pruefGroupData = {
      ID: pruefGroupId,
      Bezeichnung: pruefGroup.trim(),
    };
    setGlobalSpinner(true);
    pruefGroupId != AppConstants.DEFAULT_GUID
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
    Pruef_PlanActions.saveUpdatePruefGroup(pruefGroupData);
  };

  function handleClosePopOver() {
    if (!prufePlanDetails) {
      setPruefGroup("");
      setPruefGroupId(AppConstants.DEFAULT_GUID);
    }
    closeAddEditPruefGroupPopUpCallback();
  }

  return (
    <div
      className={`modal fade   ${equipmentGrpName ? "nestedPopover" : ""}`}
      id="addPruefGroup"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addPruefGroup"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div
        className={`modal-dialog   ${
          equipmentGrpName ? "nestedPopverMargin" : ""
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addPruefGroup">
              {prufePlanDetails
                ? localization.editPruefGroup
                : localization.addPruefGroup}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addPruefGroupModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="createPruefGroupForm"
            name="createPruefGroupFormm"
            onSubmit={pruefGroupAdd}
          >
            <div className="modal-body">
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="PruefGroup">
                      {localization.pruefGroupName}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="PruefGroup"
                      name="PruefGroup"
                      placeholder={localization.pruefGroupName}
                      required
                      value={pruefGroup}
                      onChange={(e) => {
                        e.preventDefault();
                        if (pruefGroup !== "") {
                          setPruefGroup(e.target.value);
                        } else {
                          setPruefGroup(e.target.value.trim());
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={pruefGroup.length > 0 ? false : true}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPruefGroup;
